var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-checkbox"},[_c('el-checkbox',{on:{"input":_vm.handleCheck},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }